import API from '../../Api'
import {IdentifyTypes} from "./Reducer"
import {getStateParams} from "../../Store";
import {CommonTypes} from "../../Redux/CommonTypes";

export const sendValidatePhoneLoading = () => ({
    type: IdentifyTypes.SEND_VALIDATE_PHONE_REQUEST,
});

export const sendValidatePhoneSuccess = ({validationHash, mobile, email, resentCode}) => ({
    type: IdentifyTypes.SEND_VALIDATE_PHONE_SUCCESS,
    validationHash,
    mobile, email,
    resentCode
});

export const sendValidatePhoneError = error => ({
    type: IdentifyTypes.SEND_VALIDATE_PHONE_ERROR,
    error
});

export const sendValidatePhone = (validationMethod, token, callback) => async dispatch => {
    dispatch(sendValidatePhoneLoading());
    const response = await API.validatePhone(token, validationMethod);
    if (response.ok) {
        const params = {...response.data, ...validationMethod};
        dispatch(sendValidatePhoneSuccess(params));
    } else {
        dispatch(sendValidatePhoneError(response.error));
    }

    if (callback) {
        callback(response.error, response.data)
    }
};

export const resendValidatePhone = (token, callback) => async dispatch => {
    const {validation_hash} = getStateParams();
    dispatch(resendValidatePhoneLoading());
    const response = await API.resendPhoneToken(token, validation_hash);
    if (response.ok) {
        dispatch(sendValidatePhoneSuccess({...response.data, resentCode: true}));
    } else {
        dispatch(resendValidatePhoneError(response.error));
    }

    if (callback) {
        callback(response.error, response.data)
    }
};

export const resendValidatePhoneLoading = () => ({
    type: IdentifyTypes.RESEND_VALIDATE_PHONE_REQUEST,
});

export const resendValidatePhoneError = error => ({
    type: IdentifyTypes.RESEND_VALIDATE_PHONE_ERROR,
    error
});


export const clearValidationHash = () => ({
    type: IdentifyTypes.CLEAR_VALIDATION_HASH,
});


export const validateCodeLoading = () => ({
    type: IdentifyTypes.VALIDATE_CODE_REQUEST,
});

export const validateCodeSuccess = ({validationHash}) => ({
    type: IdentifyTypes.VALIDATE_CODE_SUCCESS,
    validationHash
});

export const validateCodeError = error => ({
    type: IdentifyTypes.VALIDATE_CODE_ERROR,
    error
});

export const validateCode = (code, context, callback) => async dispatch => {
    const {validation_hash} = getStateParams();
    dispatch(validateCodeLoading());
    const response = await API.validateCode(context, validation_hash, code);
    if (response.ok) {
        dispatch(validateCodeSuccess(response.data));
    } else {
        dispatch(validateCodeError(response.error));
    }

    if (callback) {
        callback(response.error, response.data)
    }
};


export const createCustomerLoading = () => ({
    type: IdentifyTypes.CREATE_CUSTOMER_REQUEST,
});

export const createCustomerSuccess = ({updatedToken}) => ({
    type: IdentifyTypes.CREATE_CUSTOMER_SUCCESS,
    updatedToken
});

export const createCustomerError = error => ({
    type: IdentifyTypes.CREATE_CUSTOMER_ERROR,
    error
});

export const createCustomer = (token, fullName, identifyNumber, phoneNumber, email, callback) => async dispatch => {
    const {validation_hash} = getStateParams();
    dispatch(createCustomerLoading());
    const response = await API.createCustomer(token, validation_hash, fullName, identifyNumber, phoneNumber, email);
    if (response.ok) {
        dispatch(createCustomerSuccess(response.data));
    } else {
        dispatch(createCustomerError(response.error));
    }

    if (callback) {
        callback(response.error, response.data)
    }
};


export const replaceToken = updatedToken => ({
    type: IdentifyTypes.REPLACE_TOKEN,
    updatedToken
});

export const updateLastActive = currentTime => ({
    type: CommonTypes.UPDATE_ACTIVITY,
    currentTime
});


export const setLanguage = (lang, force = false) => ({
    type: CommonTypes.SET_LANGUAGE,
    lang,
    force
});

export const toggleIdentificationMode = (mode) => async (dispatch) => {
    dispatch(identificationMode(mode));
}

const identificationMode = (mode) => ({
    type: IdentifyTypes.TOGGLE_IDENTIFICATION_MODE,
    mode: mode
})
